export default __webpack_public_path__ + "static/media/fosters23.c606f391.png";